import { createGlobalStyle } from 'styled-components/macro'

const GlobalStyle = createGlobalStyle`
    body {
        padding: 10px;
        color: #333d6c;
    }
    
    body, textarea, button, input, label, select {
        font-family: Mulish, sans-serif;
    }
`

export default GlobalStyle
